import React from 'react';
import { Page } from '../layout/Page';
import { EmptyState } from '../components/shared/States';

/** Stage 1 placeholder inside the shell. Each Stage 2 lane replaces its folder's usage of this. */
export function PlaceholderPage({ icon, title, subtitle, crumbs, exportName, extraFormats, covers }) {
  return (
    <Page title={title} subtitle={subtitle} crumbs={crumbs} exportConfig={exportName ? { name: exportName, extraFormats } : undefined}>
      <EmptyState icon={icon} title={`${title} isn't built yet`} body={covers} />
    </Page>
  );
}

export const PDF_SUMMARY = (description) => [{ format: 'pdf', label: 'PDF summary', description }];
